import { useRef, useState } from "react";
import { fileUrl } from "@/lib/api";

/**
 * Before/After compare slider — draggable divider between two images.
 * before/after: gallery items with storage_path.
 */
export default function BeforeAfterSlider({ before, after, title }) {
    const [pct, setPct] = useState(50);
    const containerRef = useRef(null);

    const onMove = (clientX) => {
        const rect = containerRef.current?.getBoundingClientRect();
        if (!rect) return;
        const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
        setPct((x / rect.width) * 100);
    };

    return (
        <div className="ab-card overflow-hidden group" data-testid="before-after-slider">
            <div
                ref={containerRef}
                className="relative w-full aspect-square select-none touch-none cursor-ew-resize bg-black"
                onMouseMove={(e) => e.buttons === 1 && onMove(e.clientX)}
                onMouseDown={(e) => onMove(e.clientX)}
                onTouchMove={(e) => onMove(e.touches[0].clientX)}
                onTouchStart={(e) => onMove(e.touches[0].clientX)}
            >
                <img src={fileUrl(after.storage_path)} alt="Depois" className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
                <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ clipPath: `inset(0 ${100 - pct}% 0 0)` }}>
                    <img src={fileUrl(before.storage_path)} alt="Antes" className="w-full h-full object-cover" draggable={false} />
                </div>
                <div className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-widest bg-black/70 text-white px-2 py-1 rounded">Antes</div>
                <div className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-widest bg-[#C9A961] text-black px-2 py-1 rounded">Depois</div>
                <div className="absolute top-0 bottom-0 w-0.5 bg-[#C9A961]" style={{ left: `${pct}%` }} />
                <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-[#C9A961] border-2 border-white flex items-center justify-center shadow-xl" style={{ left: `${pct}%` }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0A0A0A" strokeWidth="3">
                        <polyline points="15 6 9 12 15 18" />
                        <polyline points="9 6 15 12 9 18" />
                    </svg>
                </div>
            </div>
            {title && (
                <div className="p-4">
                    <div className="font-heading font-bold text-white text-sm">{title}</div>
                </div>
            )}
        </div>
    );
}
